import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Compass, Users, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const META = [
  { to: "/viaje-a-medida", icon: Compass, dark: false, testid: "path-medida" },
  { to: "/viajes-en-grupo", icon: Users, dark: true, testid: "path-grupo" },
];

export default function TwoPaths() {
  const { t } = useLang();
  const cards = t("twoPaths.cards");

  return (
    <section id="servicios" data-testid="two-paths-section" className="py-24 sm:py-32 bg-[#FAF6EE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#7A571C] mb-3">{t("twoPaths.eyebrow")}</p>
          <h2 className="font-display font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B2E4A] text-balance">
            {t("twoPaths.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {Array.isArray(cards) && cards.map((c, i) => {
            const meta = META[i];
            const Icon = meta.icon;
            return (
              <motion.div
                key={c.name}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.12, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className={`rounded-3xl p-9 sm:p-12 flex flex-col transition-all duration-300 hover:-translate-y-1.5 ${
                  meta.dark
                    ? "bg-[#0B2E4A] text-[#FAF6EE] shadow-[0_24px_60px_-12px_rgba(11,46,74,0.45)]"
                    : "bg-white border border-[#E6DED1] shadow-[0_4px_20px_-2px_rgba(11,46,74,0.06)] hover:shadow-[0_16px_40px_-8px_rgba(11,46,74,0.16)]"
                }`}
              >
                <span className={`w-12 h-12 rounded-full flex items-center justify-center mb-6 ${meta.dark ? "bg-[#D9A854]/15 border border-[#D9A854]/30" : "bg-[#D9A854]/10"}`}>
                  <Icon size={22} className="text-[#D9A854]" />
                </span>
                <span className={`self-start text-[10px] font-bold uppercase tracking-[0.16em] px-3.5 py-1.5 rounded-full mb-4 ${
                  meta.dark ? "bg-[#D9A854] text-[#0B2E4A]" : "bg-[#0B2E4A]/10 text-[#0B2E4A]"
                }`}>
                  {c.tag}
                </span>
                <h3 className={`font-display font-medium text-2xl sm:text-3xl ${meta.dark ? "text-[#FAF6EE]" : "text-[#0B2E4A]"}`}>
                  {c.name}
                </h3>
                <p className={`mt-3 text-sm sm:text-base leading-relaxed flex-1 ${meta.dark ? "text-[#F1E7D6]/75" : "text-[#56636D]"}`}>
                  {c.text}
                </p>
                <Link
                  to={meta.to}
                  data-testid={`${meta.testid}-cta`}
                  className={`mt-8 inline-flex items-center gap-2 font-semibold text-sm sm:text-base transition-colors group ${
                    meta.dark ? "text-[#D9A854] hover:text-[#EE9A3C]" : "text-[#0B2E4A] hover:text-[#7A571C]"
                  }`}
                >
                  {c.cta}
                  <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
